import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {AeTaxComponent} from './ae.tax.component'
import {FormsModule} from '@angular/forms'
import {NzModule} from '../../nz.module'

@NgModule({
  declarations: [
    AeTaxComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NzModule
  ],
  exports: [
    AeTaxComponent
  ],
  providers: []
})

export class AeTaxModule {}
